import { useEffect, useRef } from 'react';

type DownloaderProps = {
  blob: string;
  filename: string;
  onDownload: () => void;
};

export const Downloader = ({ blob, filename, onDownload }: DownloaderProps) => {
  const link = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    // Asserted rather than optional-chained: the anchor is rendered
    // unconditionally below, and skipping the click instead of throwing would
    // leave the download silently not happening.
    link.current!.click();
    onDownload();

    return () => {
      URL.revokeObjectURL(blob);
    };
  }, [blob, onDownload]);

  return (
    <a ref={link} href={blob} download={filename} className="hidden">
      pdf
    </a>
  );
};
